import { render } from "./agent-nav.vue?vue&type=template&id=47254b04"
import script from "./agent-nav.js?vue&type=script&lang=js"
export * from "./agent-nav.js?vue&type=script&lang=js"

import "./agent-nav.vue?vue&type=style&index=0&id=47254b04&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__